module.exports = __webpack_public_path__ + "img/clock_brown.b42c2026.svg";